import React, { useEffect, useState } from 'react'
import { useGeolocated } from "react-geolocated";
import { Button, Col, Row } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

//Components
import MainCard from '../../components/MainCard/MainCard';
import TextField from '../../components/TextField/TextField';
import CustomizedMap from '../../components/CustomizedMap/CustomizedMap';


//Helpers
import { objCampo } from '../../helpers/ValidadorDeCampos';
import mascaras from '../../helpers/mascaras';
import { validarCampos } from '../../helpers/ValidadorDeCampos';
import { showMessage } from '../../helpers/message';

//Context
import { useAuth } from '../../context/auth';

//Api
import modalidadeColeta_api from '../../api/modalidadeColeta_api';
import cep_api from '../../api/cep_api';
import solicitacaoVistoria_api from '../../api/solicitacaoVistoria_api';

//Estado inicial da notificacao
function initialStateDenuncio(nomeSolicitado) {
    return {
        identificacaoLocalidade: "",
        cep: "",
        logradouro: "",
        cidade: "",
        bairro: "",
        uf: "",
        numero: "",
        enderecoFormatado: "",
        motivoFiscalizacao: "",
        tbTipoColeta_Id: "",
        latitude: "",
        longitude: "",
        nomeSolicitante: nomeSolicitado,
        Status: "Pendente",
        tbSetores_Id: "",
        complemento: "",
        cpfcnpj: "",
        email: "",
        DataSolicitacao: moment().format("YYYY-MM-DD")
    }
}

export default function Denuncia() {
    const { setLoading, setupVariavel, session } = useAuth();

    const { coords, isGeolocationAvailable, isGeolocationEnabled } = useGeolocated({ positionOptions: { enableHighAccuracy: false, }, userDecisionTimeout: 5000 });

    const [denuncia, setDenuncia] = useState(initialStateDenuncio(session?.acesso?.acesso_descricao));

    //Estado de controle dos erros nos campos da notificacao
    const [errors, setErrors] = useState({});

    //Estados que guardam as opções de ramos de atividade e modalidades de coleta
    const [optionsModalidades, setOptionsModalidades] = useState([]);

    //Campos obrigatorios da notificacao
    const campos = [
        objCampo({ name: "identificacaoLocalidade", required: true }),
        objCampo({ name: "cep", required: true }),
        objCampo({ name: "bairro", required: true }),
        objCampo({ name: "logradouro", required: true }),
        objCampo({ name: "cidade", required: true }),
        objCampo({ name: "uf", required: true }),
        objCampo({ name: "numero", required: true }),
        objCampo({ name: "motivoFiscalizacao", required: true }),
        objCampo({ name: "tbTipoColeta_Id", required: true })
    ];

    const loadOptionsModalidade = () => {
        setLoading(true);
        modalidadeColeta_api.GetList().then(response => {
            setOptionsModalidades(response.data.map(value => { return { value: value.id, label: value.descricao } }));
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Função de onChange dos dados da notificação
    const onChangeDenuncia = (e) => {
        const { name, value } = e.target;

        const _denuncia = {
            ...denuncia,
            [name]: value
        }

        const erros = validarCampos(_denuncia, campos.filter(c => c.name == name));
        if (erros[1].length == 0) {
            const _errors = { ...errors };
            delete _errors[name];
            setErrors(_errors);
        }

        setDenuncia(_denuncia);
    }

    //Função de onchange do campo de tbTipoColeta_Id
    const onChangeModalidadeColeta = (e, select) => {
        const { name } = select;
        setDenuncia({
            ...denuncia,
            [name]: e ? e.value.toString() : e,
        });
    }

    const loadLatituLongitude = async (_denuncia, viaCep = false) => {
        try {

            const endereco = {
                NumeroCep: viaCep ? _denuncia.cep : "",
                Bairro: viaCep ? _denuncia.bairro : "",
                Logradouro: viaCep ? _denuncia.logradouro : "",
                Cidade: viaCep ? _denuncia.cidade : "",
                Estado: viaCep ? _denuncia.estado : "",
                Numero: viaCep ? _denuncia.numero : "",
                Latitude: _denuncia.latitude ?? "",
                Longitude: _denuncia.longitude ?? "",
                EnderecoFormatado: "",
            };

            setLoading(true);
            var result = await cep_api.GeoCode(endereco);

            if (result && result.data) {
                _denuncia.bairro = result.data?.bairro ?? "";
                _denuncia.cidade = result.data?.cidade ?? "";
                _denuncia.logradouro = result.data?.logradouro ?? "";
                _denuncia.numero = result.data?.numero ?? "";

                _denuncia.cep = result.data?.numeroCep ?? "";
                _denuncia.uf = result.data?.uf ?? "";

                _denuncia.latitude = parseFloat(result.data.latitude.replace(",", "."));
                _denuncia.longitude = parseFloat(result.data.longitude.replace(",", "."));
                _denuncia.enderecoFormatado = result.data?.enderecoFormatado ?? "";
                setDenuncia(_denuncia);
            }
        } catch (error) {
            showMessage("Aviso", error?.message ?? "Erro na Operação.", "error", null);
        } finally {
            setLoading(false)
        }
    }

    //Change para o mapa pegando a longitude e latitude
    const onChangeLocation = async (location) => {
        const _denuncia = { ...denuncia, latitude: location.lat, longitude: location.lng }
        await loadLatituLongitude(_denuncia);
    }

    //OnBlur para o campo de cep do endereço
    const onBlurCep = async (e) => {
        const { name, value } = e.target;
        const _denuncia = {
            ...denuncia,
            [name]: value
        }

        _denuncia.cep = mascaras.cepMask(_denuncia.cep, true);

        if (_denuncia.cep.length == 8) {
            setLoading(true);
            cep_api.get(_denuncia.cep).then(async response => {
                if (response.data.erro) {
                    showMessage("Aviso", "CEP não encontrado na base de dados", "error", null);
                    return;
                }
                _denuncia.bairro = response.data.bairro;
                _denuncia.uf = response.data.uf;
                _denuncia.logradouro = response.data.logradouro;
                _denuncia.cidade = response.data.localidade;

                await loadLatituLongitude(_denuncia, true);
            }).catch(e => {
                showMessage("Aviso", "CEP não encontrado na base", "error", null);
            }).finally(f => setLoading(false));
        }
    }

    const onsubmitDenuncia = () => {
        const _errors = validarCampos(denuncia, campos);
        if (_errors[1].length > 0) {
            setErrors(_errors[0]);
            return;
        }

        const _denuncia = { ...denuncia };

        setLoading(true);
        solicitacaoVistoria_api.Post(_denuncia).then(response => {
            showMessage("Sucesso", "Denúncia realizada com sucesso", "success", () => {
                if (isGeolocationAvailable && isGeolocationEnabled && coords) {
                    if (!!coords.latitude && !!coords.longitude) {
                        let _denuncia = { ...initialStateDenuncio(session?.acesso?.acesso_descricao), latitude: coords.latitude, longitude: coords.longitude }
                        loadLatituLongitude(_denuncia);
                    } else if (setupVariavel?.coordenadaPrefeitura) {
                        const [latitude, longitude] = setupVariavel?.coordenadaPrefeitura.split(";");
                        let _denuncia = { ...initialStateDenuncio(session?.acesso?.acesso_descricao), latitude: parseFloat(latitude), longitude: parseFloat(longitude) }
                        loadLatituLongitude(_denuncia);
                    };
                } else {
                    const [latitude, longitude] = setupVariavel?.coordenadaPrefeitura.split(";");
                    let _denuncia = { ...initialStateDenuncio(session?.acesso?.acesso_descricao), latitude: parseFloat(latitude), longitude: parseFloat(longitude) }
                    loadLatituLongitude(_denuncia);
                };
            });
        })
            .catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }


    //Carrega as opções dos estados
    useEffect(() => {
        if (isGeolocationAvailable && isGeolocationEnabled && coords) {
            if (!!coords.latitude && !!coords.longitude) {
                let _denuncia = { ...denuncia, latitude: coords.latitude, longitude: coords.longitude }
                loadLatituLongitude(_denuncia);
            } else if (setupVariavel?.coordenadaPrefeitura) {
                const [latitude, longitude] = setupVariavel?.coordenadaPrefeitura.split(";");
                let _denuncia = { ...denuncia, latitude: parseFloat(latitude), longitude: parseFloat(longitude) }
                loadLatituLongitude(_denuncia);
            };
        } else {
            const [latitude, longitude] = setupVariavel?.coordenadaPrefeitura.split(";");
            let _denuncia = { ...denuncia, latitude: parseFloat(latitude), longitude: parseFloat(longitude) }
            loadLatituLongitude(_denuncia);
        };

        loadOptionsModalidade();
    }, [isGeolocationAvailable, isGeolocationEnabled, coords]);

    return (
        <MainCard>
            <Row className='mb-4'>
                <Col md="12" lg="12"><span className="text-danger fw-bold">*</span> Campos obrigatórios</Col>
            </Row>
            <Row>

                <Col md="12" lg="8">
                    <TextField
                        label="* identificacaoLocalidade"
                        name="identificacaoLocalidade"
                        value={denuncia.identificacaoLocalidade}
                        invalid={errors.identificacaoLocalidade}
                        onChange={onChangeDenuncia} />
                </Col>

                <Col md="12" lg="4">
                    <TextField
                        placeholder="Todos"
                        label="Modalidade de coleta"
                        searchable
                        name="tbTipoColeta_Id"
                        value={optionsModalidades.filter(value => value.value == denuncia.tbTipoColeta_Id)[0]}
                        invalid={errors.tbTipoColeta_Id}
                        onChange={onChangeModalidadeColeta}
                        type="select"
                        options={optionsModalidades} />
                </Col>

                <Col md={"12"} lg={"3"}>
                    <TextField
                        label={"* CEP"}
                        maxLength={"9"}
                        mask={mascaras.cepMask}
                        invalid={errors.cep ? true : false}
                        name="cep"
                        value={denuncia.cep}
                        onChange={onChangeDenuncia}
                        onBlur={onBlurCep}
                    />
                </Col>

                <Col md={"12"} lg={"1"}>
                    <TextField
                        label={"* UF"}
                        maxLength={"2"}
                        invalid={errors.uf ? true : false}
                        name="uf"
                        value={denuncia.uf}
                        onChange={onChangeDenuncia}
                    />
                </Col>

                <Col md={"12"} lg={"4"} >
                    <TextField
                        label={"* Cidade"}
                        maxLength={"150"}
                        invalid={errors.cidade ? true : false}
                        name="cidade"
                        value={denuncia.cidade}
                        onChange={onChangeDenuncia}
                    />
                </Col>

                <Col md={"12"} lg={"4"}>
                    <TextField
                        label={"* Bairro"}
                        maxLength={"100"}
                        invalid={errors.bairro ? true : false}
                        name="bairro"
                        value={denuncia.bairro}
                        onChange={onChangeDenuncia}
                    />
                </Col>

                <Col md={"12"} lg={"4"}>
                    <TextField
                        label={"* Logradouro"}
                        maxLength={"300"}
                        invalid={errors.logradouro ? true : false}
                        name="logradouro"
                        value={denuncia.logradouro}
                        onChange={onChangeDenuncia}
                    />
                </Col>

                <Col md={"12"} lg={"4"}>
                    <TextField
                        label={"* Número"}
                        maxLength={"50"}
                        invalid={errors.numero ? true : false}
                        name="numero"
                        value={denuncia.numero}
                        onChange={onChangeDenuncia}
                        mask={mascaras.numeroMask}
                    />
                </Col>

                <Col md={"12"} lg={"4"}>
                    <TextField
                        label={"Complemento"}
                        maxLength={"200"}
                        invalid={errors.complemento ? true : false}
                        name="complemento"
                        value={denuncia.complemento}
                        onChange={onChangeDenuncia}
                    />
                </Col>

                <Col md={"12"} lg={"12"}>
                    <TextField
                        label="* Motivo da Fiscalização"
                        type={"textarea"}
                        name={"motivoFiscalizacao"}
                        value={denuncia.motivoFiscalizacao}
                        onChange={onChangeDenuncia}
                        invalid={errors.motivoFiscalizacao ? true : false}
                    />
                </Col>
            </Row>

            <Row className='d-flex align-items-center justify-content-center my-3'>
                <div
                    className='col-md-12 col-lg-12 shadow rounded-3 overflow-hidden m-0 p-0 mb-4'
                    style={{ width: "95%", height: "250px" }}
                >
                    <CustomizedMap
                        positionCenter
                        addNewMarker
                        position={{ lat: denuncia.latitude ? denuncia.latitude : "", lng: denuncia.longitude ? denuncia.longitude : "" }}
                        setPosition={onChangeLocation}
                        zoom={19}
                    />
                </div>
                {denuncia?.enderecoFormatado && <h4 className='px-4' style={{ color: "#666" }}>{denuncia?.enderecoFormatado}</h4>}
            </Row>

            <Row className='d-flex justify-content-center align-items-center'>
                <Col md={"12"} lg={"2"}>
                    <Button color='success' className='w-100' onClick={onsubmitDenuncia}>
                        <FontAwesomeIcon icon={faSave} />  Salvar
                    </Button>
                </Col>
            </Row>
        </MainCard>
    )
}


